<template>
    <div class="account min-height">
        <div class="flex align-center justify-between margin-bottom">
            <div class="flex align-center ">
                <el-input placeholder="请输入姓名/手机号" v-model="searchName"></el-input>
                <el-button type="primary" class="margin-left" @click="search">搜索</el-button>
            </div>
            <el-button type="primary" @click="handleAdd">添加帐号</el-button>
        </div>
        <el-table
            :data="tableData"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            border
            style="width: 100%">
            <el-table-column
                type="index"
                label="序号"
                width="80">
            </el-table-column>
            <el-table-column
                prop="user_name"
                label="姓名"
            >
            </el-table-column>
            <el-table-column
                prop="tel_number"
                label="手机号"
            >
            </el-table-column>
            <el-table-column
                prop="user_role_name"
                label="类型">
            </el-table-column>
            <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <div class="flex align-center justify-around" v-if="scope.row.user_role !== 0">
                        <el-button @click="handleEdit(scope.row)" type="text" class="padding-0 font-size-sm">编辑
                        </el-button>
                        <el-button @click="handleDelete(scope.row.id)" type="text" class="padding-0 font-size-sm red">
                            删除
                        </el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData.length > 0"
            class="page-all"
            background
            @current-change="getList"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

        <el-dialog
            :title="setId?'编辑帐号':'新增帐号'"
            :visible.sync="dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="480px"
            center>
            <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="70px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="accountForm.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="accountForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass" v-if="!setId">
                    <el-input v-model="accountForm.pass" placeholder="请输入密码" disabled></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="power">
                    <el-select v-model="accountForm.power" placeholder="请选择角色类型" style="width: 100%;">
                        <el-option
                            v-for="item in powerList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import {getAccount, deleteAccount, createAdminAccount, editAccount} from "@/api/admin";
import {optionList, powerList, filesCN} from '@/utils/utils'
import rules from "@/utils/rules";

export default {
    name: "account",
    data() {
        return {
            searchName: '',
            page: 1,
            limit: 10,
            total: 0,
            tableData: [],
            setId: 0,
            dialog: false,
            setItem: null,
            powerList: optionList(false, powerList),
            accountForm: {
                name: '',
                phone: '',
                pass: '123456（默认密码）',
                power: '',
            },
            rules: {
                name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                phone: rules.phone,
                pass: [{required: true, message: '请输入密码', trigger: 'blur'}],
                power: [{required: true, message: '请选择角色', trigger: 'change'}]
            }
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "帐号管理  / ", false, 'icon-zhanghao');
        this.getList()
    },
    components: {},
    methods: {
        //  帐号删除
        handleDelete(id) {
            this.$confirm('此操作将永久删除该管理帐号, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true,
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        //  确认删除
        async sureDelete(id) {
            let _data = await deleteAccount(id)
            this.$message.success(_data.msg)
            await this.getList()
        },
        //  确认添加
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            if (this.setId) {
                let _state = await editAccount(
                    this.accountForm.name,
                    this.accountForm.phone,
                    this.accountForm.power,
                    this.setId
                );
                if(_state.status === 200) this.$message.success(_state.msg);
            } else {
                let _state = await createAdminAccount(
                    this.accountForm.name,
                    this.accountForm.phone,
                    this.accountForm.power,
                );
                if(_state.status === 200) this.$message.success(_state.msg);
            }
            this.$refs[formName].resetFields();
            this.setId = 0
            this.setItem = null
            this.dialog = false
            await this.getList()
        },
        //  编辑框显示
        handleEdit(item) {
            this.setId = item.id
            this.setItem = item
            this.accountForm.name = item.user_name
            this.accountForm.phone = item.tel_number
            this.accountForm.power = item.user_role
            this.dialog = true
        },
        //  编辑框关闭
        resetForm() {
            this.setId = 0
            this.setItem = null
            this.accountForm= {
                name: '',
                phone: '',
                pass: '123456（默认密码）',
                power: '',
            }
            this.$refs.accountForm.clearValidate()
            this.dialog = false

        },
        //  添加子管理
        handleAdd() {
            this.setId = 0
            this.setItem = null
            this.accountForm= {
                name: '',
                phone: '',
                pass: '123456（默认密码）',
                power: '',
            }
            this.dialog = true
            this.$refs.accountForm.clearValidate()

        },
        search(){
            this.page = 1
            this.getList()
        },
        //  获取列表
        async getList() {
            let _list = await getAccount(this.searchName, this.page, this.limit)
            _list.data.map(item => {
                item.user_role_name = filesCN(item.user_role, powerList)
            })
            this.tableData = _list.data
            this.total = _list.total
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.account {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
}
</style>